export function initMasonry() {
    const elements = [...document.querySelectorAll('.ce-gallery-masonry')];

    if (!elements.length) {
        return;
    }

    import('$c3local/Lib/masonry/masonry.js').then(() => {
        elements.forEach(element => {
            const container = element.querySelector('.ce-inner');
            const masonry = new Masonry(container, {
                gutter: getGutter()
            });

            window.addEventListener('resize', () => {
                masonry.options.gutter = getGutter();
                masonry.layout();
            });
        });
    });
}

function getGutter() {
    if (window.innerWidth > 990) {
        return 40;
    }
    return 32;
}